module.exports = __webpack_public_path__ + "img/15.png.11bac739.webp";